exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1g2WZ {\n  background-color: #404242;\n  text-align: center;\n  font-size: 12px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  color: #A0A0A0;\n}\n._3N1EX {\n  margin-top: 5px;\n  padding-top: 10px;\n  height: 300px;\n  overflow: auto;\n}\n._3N1EX ul {\n  margin: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"desc": "_1g2WZ",
	"list": "_3N1EX"
};